export type CardPaymentProviders = 'STRIPE_V2' | 'CHECKOUT';

export const DEFAULT_CARD_PAYMENT_PROVIDER: CardPaymentProviders = 'CHECKOUT';
